import { Component, effect, inject, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CopilotFacadeService } from '@brighthub/copilot';
import { Router } from '@angular/router';
import { EmployeeSearchService } from '../employee-search.service';
import { EmployeeListService } from '../employee-list.service';
import { ConversationInfoComponent } from '@brighthub/brightnav-conversation-search';
import { ScrollRegionComponent } from '@brightside/angular-bds';
import { Tooltip } from 'primeng/tooltip';
import { UiSession } from '@brighthub/uisession';
import { ClientInfoSkeletonComponent } from '@brightnav/ui';

@Component({
  selector: 'lib-employee-conversation-list',
  imports: [
    CommonModule,
    ConversationInfoComponent,
    ScrollRegionComponent,
    Tooltip,
    ClientInfoSkeletonComponent,
  ],
  templateUrl: './employee-conversation-list.component.html',
  styleUrl: './employee-conversation-list.component.scss',
})
export class EmployeeConversationListComponent {
  @Input() collapsed = false;
  private _copilotFacadeService = inject(CopilotFacadeService);
  private _employeeListService = inject(EmployeeListService);
  private _router = inject(Router);

  employeeListService = inject(EmployeeListService);
  employeeSearchService = inject(EmployeeSearchService);

  constructor() {
    effect(() => {
      const activeEmployee = this.employeeSearchService.activeEmployee();
      if (activeEmployee) {
        this.employeeListService.getSessionsByOktaId(activeEmployee.id);
      }
    });
  }

  routeTo() {
    this._copilotFacadeService.clearContext();
    this._router.navigate(['/brightnav/myclients']);
  }

  conversationSelected(conversation: UiSession) {
    this._employeeListService.activeConversation.set(conversation);
  }
}
